import { formatMoneyKzt } from "@/features/accounting/shared";

interface ReportAmount {
  text: string;
  isNegative: boolean;
}

export function formatReportAmount(amount: string | number): ReportAmount {
  const num = typeof amount === "string" ? parseFloat(amount) : amount;
  const isNegative = !isNaN(num) && num < 0;
  return {
    text: isNegative ? `(${formatMoneyKzt(Math.abs(num))})` : formatMoneyKzt(amount),
    isNegative,
  };
}
